module.exports = __webpack_public_path__ + "static/img/アセット 87@3x.832b546.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 87@3x.png
// module id = LBLQ
// module chunks = 1